var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.authorized)?_c('div',[_vm._t("default")],2):_c('div',[_vm._v("Je hebt geen admin toegang")])])}
var staticRenderFns = []

export { render, staticRenderFns }